import { render, staticRenderFns } from "./StepPhoneNumber.vue?vue&type=template&id=d5549704&scoped=true&"
import script from "./StepPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./StepPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./StepPhoneNumber.vue?vue&type=style&index=0&id=d5549704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5549704",
  null
  
)

export default component.exports